const selfSelector = (state) => state.analytic;

export default selfSelector;
